"use client";

import { RequestInfo } from "rwsdk/worker";
import { AppLayout } from "@/components/layouts/AppLayout";
import { HelpClient } from "@/components/help/HelpClient";

function Help({ ctx }: RequestInfo) {
  return (
    <AppLayout ctx={ctx}>
      <HelpClient user={ctx.user} />
    </AppLayout>
  );
}

export { Help };